module.exports = __webpack_public_path__ + "static/media/default-avatar.f4292014.jfif";